<template>
  <mdb-container>
    <mdb-card class="text-left mt-4 mb-4">
      <mdb-card-header class="primary-color text-white">
        <h4>Virtual Assistant Tasks
          <span v-if="type=='event'">(This Event)</span>
          <span v-if="type=='group'">(This Group's Defaults)</span>
          <span v-if="type=='user'">(My Defaults)</span>
        </h4>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="doCancel" rounded size="sm" v-if="type=='event'">
          <mdb-icon icon="arrow-left"/>
          Back to Main
        </mdb-btn>
        <mdb-btn @click="addTask" icon="plus-circle" rounded size="sm">Add</mdb-btn>
        <mdb-btn @click="$router.push('/group/' + group.vanityPath + '/assistant')"
                 icon="list" rounded size="sm" v-if="group && group.role=='Admin' && type != 'group'">Manage
          Group Tasks
        </mdb-btn>
        <mdb-btn @click="$router.push('/user/assistant')" icon="list" rounded size="sm" v-if="type != 'user'">Manage My
          Tasks
        </mdb-btn>

        <mdb-btn @click="showHelp=true" icon="question" rounded size="sm">What is this?</mdb-btn>
        <div v-if="tasks && tasks.length == 0">
          <div class="h5 text-info">
            <p v-if="type=='event'">This event doesn't have any tasks set up.</p>
            <p v-if="type=='group'">This group doesn't have any default tasks set up.</p>
            <p v-if="type=='user'">You don't have any default tasks set up.</p>
          </div>
        </div>

        <mdb-tbl responsive striped v-if="tasks && tasks.length>0">
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>Trigger</th>
              <th>Task</th>
              <th v-if="type=='event'">Status</th>
              <th></th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr class="text-left" v-for="t in tasks">
              <td> {{t.days}} {{t.days == 1 ? 'day' : 'days'}} {{t.beforeAfter}} at {{t.triggerTimeOnly}}
                <p v-if="type=='event' && t.triggerTime">{{t.triggerTime}}</p>
              </td>
              <td>{{t.taskAction}} <span v-if="t.taskAction == 'Send Reminder' || t.taskAction=='Follow-up Message'">({{t.reminderTarget}})</span>
              </td>
              <td v-if="type=='event'">{{t.execResults}}
                <p v-if="t.completedDate">{{t.completedDate}}</p></td>
              <th>
                <mdb-btn @click="editTask(t)" icon="pencil" rounded size="sm"/>
                <mdb-btn @click="deleteTask(t)" color="danger" icon="trash" rounded size="sm" v-if="t.allowEdit"/>
              </th>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>
    </mdb-card>
    <mdb-modal :show="editModal" class="text-left" size="lg" v-if="editModal">
      <mdb-modal-header :close="false" class="primary-color text-center text-white">
        <h5>Edit Task</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="text-info" v-if="!taskEditWork.allowEdit">This task may no longer be modified.</div>
        <div class="mb-4 mt-4">
          <mdb-row>
            <mdb-col col="1"></mdb-col>
            <mdb-col col="3">
              <mdb-input label="Days" placeholder="# Days" type="number" :disabled="!taskEditWork.allowEdit" v-model="taskEditWork.days"/>
            </mdb-col>
            <mdb-col col="8">
              <mdb-input id="ba1" label="Before" name="radioGroup3" radioValue="before" type="radio"
                         :disabled="!taskEditWork.allowEdit"
                         v-model="taskEditWork.beforeAfter"/>
              <mdb-input id="ba2" label="After" name="radioGroup3" radioValue="after" type="radio"
                         :disabled="!taskEditWork.allowEdit"
                         v-model="taskEditWork.beforeAfter"/>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col col="1"></mdb-col>
            <mdb-col col="1">At</mdb-col>
            <mdb-col class="md-form" col="4">
              <datetime :auto="true"
                        :format="(userDetails.timeFormat=='AM/PM' ? 'hh:mm a' : 'HH:mm')"
                        :use12-hour="userDetails.timeFormat=='AM/PM'" :valueZone="userDetails.timezone.ID"
                        :weekStart="userDetails.mondayFirst ? 1 : 7" inputId="startDate"
                        :disabled="!taskEditWork.allowEdit"
                        type="time"
                        v-model="taskEditWork.triggerTimeRaw">
              </datetime>
            </mdb-col>
            <mdb-col col="6"/>
          </mdb-row>
          <mdb-row v-if="type=='event' && taskEditWork.triggerTime && taskEditWork.allowEdit">
            <mdb-col col="12">
              <div class="text-info text-center"><b>Scheduled Trigger: </b><i>{{taskEditWork.triggerTime}}</i></div>
            </mdb-col>
          </mdb-row>

          <gp-select :dataObj="taskEditWork" :possible-values="beforeActions" :required="true"
                     label="Action" propertyName="taskAction"
                     :disabled="!taskEditWork.allowEdit"
                     v-if="taskEditWork.beforeAfter=='before'"/>
          <gp-select :dataObj="taskEditWork" :possible-values="afterActions" :required="true"
                     :disabled="!taskEditWork.allowEdit"
                     label="Action" propertyName="taskAction"
                     v-if="taskEditWork.beforeAfter=='after'"/>
        </div>

        <div class="mb-4 mt-4" v-if="taskEditWork.taskAction == 'Send Reminder'">
          <gp-select :dataObj="taskEditWork" :possible-values="beforeTargets"
                     :required="true" label="Send To"
                     :disabled="!taskEditWork.allowEdit"
                     propertyName="reminderTarget"/>
        </div>
        <div class="mb-4 mt-4" v-if="taskEditWork.taskAction == 'Follow-up Message'">
          <gp-select :dataObj="taskEditWork" :possible-values="afterTargets"
                     :required="true" label="Send To"
                     :disabled="!taskEditWork.allowEdit"
                     propertyName="reminderTarget"/>
        </div>


        <mdb-row
          v-if="taskEditWork.taskAction == 'Send Reminder' || taskEditWork.taskAction == 'Announce' || taskEditWork.taskAction == 'Follow-up Message'">
          <mdb-col col="12">
            <div class="small ml-2" v-if="taskEditWork.beforeAfter == 'before'">
              The notification will automatically include the event title and times along with a link
              to the event. Use the text area below to add any additional information the notification.
            </div>
            <editor :disabled="!taskEditWork.allowEdit" :init="editorConfig" v-model="taskEditWork.emailText">
            </editor>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn v-if="taskEditWork.allowEdit" @click="doSave" color="success" icon="save" :disabled="!validToSave">
          Save
        </mdb-btn>
        <mdb-btn @click="cancelEdit" color="danger">
          <mdb-icon icon="window-close"/>
          {{taskEditWork.allowEdit ? 'Cancel' : 'Close'}}
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal :show="deleteModal" @close="deleteModal = false" class="text-center" danger size="sm">
      <mdb-modal-header :close="false" center>
        <p class="heading">Are you sure you wish to delete this task?</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-icon class="animated rotateIn" icon="times" size="4x"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click="doDelete" color="danger">Yes</mdb-btn>
        <mdb-btn @click="deleteModal = false" color="success">No</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal :show="showHelp" @close="showHelp = false" class="text-center" size="sm">
      <mdb-modal-header :close="true" center class="secondary-color text-white">
        <p class="heading">About Virtual Assistant</p>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <p>The virtual assistant lets you set tasks to execute on your events. Tasks can be to send announcements
          or reminders, or to open/close the event for reservations.</p>
        <p>When you create a new event from scratch, tasks are added to the event from the defaults. There are
          two types of default: group and user. If you have personal defaults set up, they will be defaulted
          to any new event that you create. Otherwise, group defaults will be used.</p>
        <p>If no user or group default tasks exist at all, then a basic announcement task will be generated.</p>
        <p>When you clone an existing event, that event's tasks are copied</p>
        <p>Your event can only be announced once. Use reminder tasks for subsequent notifications.</p>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbSelect,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

import {Datetime} from 'vue-datetime'
import gpSelect from "../common/GPSelect";
import moment from 'moment'
import editor from '@tinymce/tinymce-vue'

export default {
    name: 'Virtual-Assistant',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput, mdbCard, mdbCardHeader, mdbCardBody,
      mdbContainer, mdbTbl, mdbTblHead, mdbTblBody,
      mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter,
      mdbRow, mdbCol, mdbSelect,
      gpSelect, editor,
      Datetime
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: "event"
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      },
      taskAction() {
        if (!this.taskEditWork) return null
        return this.taskEditWork.taskAction
      },
      taskDays() {
        if (!this.taskEditWork) return null
        return this.taskEditWork.days
      },
      beforeAfter() {
        if (!this.taskEditWork) return null
        return this.taskEditWork.beforeAfter
      },
      triggerTimeRaw() {
        if (!this.taskEditWork) return null
        return this.taskEditWork.triggerTimeRaw
      },
      validToSave() {
        let ret = true
        if (!this.taskEditWork.taskAction) ret = false
        if (this.taskEditWork.taskAction == "Send Reminder" && !this.validChoice(this.beforeTargets, this.taskEditWork.reminderTarget)) ret = false
        if (this.taskEditWork.taskAction == "Follow-up Message" && !this.validChoice(this.afterTargets, this.taskEditWork.reminderTarget)) ret = false
        if (isNaN(this.taskEditWork.days)) {
          console.log("Not a number!", this.taskEditWork.days)
          ret = false;
        }
        if (this.taskEditWork.taskAction == "Follow-up Message" && !this.taskEditWork.emailText) ret = false
        return ret
      }
    },
    watch: {
      taskDays(n,o) {
        this.getTriggerText()
      },
      beforeAfter(n,o) {
        this.getTriggerText()
      },
      triggerTimeRaw(n,o) {
        this.getTriggerText()
      }

    },
    data() {
      return {
        tasks: [],
        showSeriesModal: false,
        seriesChoice: null,
        showSave: false,
        editModal: false,
        showHelp: false,
        taskEditWork: {
          id: null,
          taskAction: "",
          days: null,
          beforeAfter: "",
          reminderTarget: "",
          emailText: "",
          triggerTimeRaw: "",
          triggerTime : ""
        },
        editorConfig: {
          browser_spellcheck: true,
          branding: false,
          plugins: ["link", "code", "paste", "table", "lists", "image"],
          toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | link unlink code | image "],
          style_formats_merge: true,
          paste_as_text: true,
          relative_urls: false,
          remove_script_host: false,
          height: 400
        },
        currentTask: null,
        deleteModal: false,
        beforeActions: [{text: "Announce", value: "Announce"},
          {text: "Send Reminder", value: "Send Reminder"},
          {text: "Open for Reservations", value: "Open for Reservations"},
          {text: "Close to Reservations", value: "Close to Reservations"}],
        afterActions: [{text: "Follow-up Message", value: "Follow-up Message"}],
        beforeTargets: [{text: "Confirmed Members", value: "Confirmed Members"},
          {text: "Waitlisted Members", value: "Waitlisted Members"},
          {text: "No Response Members ", value: "No Response Members"},
          {text: "Not Going Members", value: "Not Going Members"}],
        afterTargets: [{text: "Members Attended", value: "Members Attended"},
          {text: "No Shows", value: "No Shows"}]
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/task/" + this.type + "/list/" + this.id).then(
        (results) => {
          this.tasks = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load tasks. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      getTriggerText() {
        if (this.taskEditWork.days === null) return
        if (!this.taskEditWork.beforeAfter) return
        if (!this.taskEditWork.triggerTimeRaw) return
        if (this.type != "event") return
        if (!this.taskEditWork.triggerTimeRaw) return
        let payload = {
          eventId: this.id,
          days: this.taskEditWork.days,
          beforeAfter: this.taskEditWork.beforeAfter,
          triggerTimeRaw: this.taskEditWork.triggerTimeRaw
        }
        api.post("/task/" + this.type + "/getTriggerTime", payload).then(
          (results) => {
            //this.tasks = results.data;
            this.taskEditWork.triggerTime = results.data
          },
          (error) => {

          })
      },
      validChoice(arr, val) {
        let validOption = false
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].value == val) validOption = true
        }
        return validOption
      },
      clearWork() {
        this.taskEditWork.id = null
        this.taskEditWork.taskAction = ""
        this.taskEditWork.days = 0
        this.taskEditWork.beforeAfter = ""
        this.taskEditWork.reminderTarget = ""
        this.taskEditWork.emailText = ""
        this.taskEditWork.triggerTimeRaw = ""
        this.taskEditWork.triggerTime = ""
      },
      cancelEdit() {
        this.clearWork()
        this.currentTask = null
        this.editModal = false
      },
      editTask(t) {
        this.clearWork()
        this.currentTask = t
        this.taskEditWork.id = t.id
        this.taskEditWork.taskAction = t.taskAction
        this.taskEditWork.days = t.days
        this.taskEditWork.beforeAfter = t.beforeAfter
        this.taskEditWork.reminderTarget = t.reminderTarget
        this.taskEditWork.emailText = t.emailText
        this.taskEditWork.triggerTimeRaw = t.triggerTimeRaw
        this.taskEditWork.triggerTime = t.triggerTime
        this.taskEditWork.allowEdit = t.allowEdit
        if (!this.taskEditWork.reminderTarget) this.taskEditWork.reminderTarget = "Confirmed Members"
        this.editModal = true
      },
      deleteTask(q) {
        this.currentTask = q
        this.deleteModal = true
      },
      addTask() {
        this.showSave = true
        this.taskEditWork = {
          id: null,
          taskAction: "Announce",
          days: 14,
          beforeAfter: "before",
          reminderTarget: "Confirmed Members",
          emailText: "",
          triggerTimeRaw: moment().set('h', 22).set('m', 0).format(),
          triggerTime: "",
          allowEdit: true
        }
        this.editModal = true
      },
      doCancel() {
        this.$emit("cancel")
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.doSave()
      },
      doSave() {
        if (this.taskEditWork.taskAction == "Announce") {
          let announceCount = 1
          for (let i=0; i<this.tasks.length; i++) {
            let t = this.tasks[i]
            if (t.taskAction == "Announce" && t.id != this.taskEditWork.id) announceCount++
          }
          if (announceCount > 1) {
            this.$notify.error({message: "An event can only have 1 announcement task.", timeOut: 10000})
            return
          }
        }

        this.editModal = false
        this.$store.dispatch("setExecuting", true);

        api.post("/task/" + this.type + "/save/" + this.id, this.taskEditWork).then(
          (results) => {
            if (this.taskEditWork.id) Object.assign(this.currentTask, results.data)
            else (this.tasks.push(results.data))
            this.currentTask = null;
            this.clearWork()
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
            this.editModal = true
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doDelete() {
        this.deleteModal = false
        this.$store.dispatch("setExecuting", true)
        api.delete("/task/" + this.type + "/delete/" + this.id + "?task=" + this.currentTask.id).then(
          (results) => {
            let loc = this.tasks.indexOf(this.currentTask)
            this.tasks.splice(loc, 1)
            this.currentTask = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }
  }
  ;
</script>
<style lang="scss">
  @import '~vue-datetime/dist/vue-datetime.min';
</style>
